// extracted by mini-css-extract-plugin
module.exports = {"switcher":"LocaleSwitcher-module_switcher__1ilZI","current":"LocaleSwitcher-module_current__ZQvAH","select":"LocaleSwitcher-module_select__2tMoa"};